import React from 'react';
import { 
  Typography, 
  TextField, 
  Grid, 
  Box 
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useStyles } from '../../pages/projects/list/styles/projectFormModalStyles';

// ----------------------------------------------------------------------

export default function EmploymentInfoSection({
  isEditing,
  values,
  errors,
  touched,
  getFieldProps,
  setFieldValue
}) {
  const classes = useStyles();
  const renderField = (fieldName, label) => {
    if (isEditing) {
      if (fieldName === 'joiningDate') {
        return (
          <DatePicker
            label="Joining Date"
            value={values.joiningDate}
            inputFormat='DD MMM YYYY'
            onChange={(newValue) => setFieldValue('joiningDate', newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                variant="outlined"
                error={touched.joiningDate && Boolean(errors.joiningDate)}
                helperText={touched.joiningDate && errors.joiningDate}
              />
            )}
          />
        );
      }

      return (
        <TextField
          fullWidth
          label={label}
          {...getFieldProps(fieldName)}
          error={touched[fieldName] && Boolean(errors[fieldName])}
          helperText={touched[fieldName] && errors[fieldName]}
          variant="outlined"
        />
      );
    }

    // View mode
    const getDisplayValue = () => {
      if (fieldName === 'joiningDate') {
        return values.joiningDate ? dayjs(values.joiningDate).format('DD MMM YYYY') : 'Not provided';
      }
      return values[fieldName] || 'Not provided';
    };

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: .5 }}>
        <Typography variant="body2" color="text.secondary" sx={{ minWidth: '140px' }}>
          {label}:
        </Typography>
        <Typography variant="body1">
          {getDisplayValue()}
        </Typography>
      </Box>
    );
  };

  return (
    <>
      <Typography variant="h6" className={classes.memberUpdateModelTitle}>
        Employment Information
      </Typography>
      
      <Grid container spacing={isEditing ? 3 : 1}>
        <Grid item xs={12}>
          {renderField('jobTitle', 'Job Title')}
        </Grid>

        <Grid item xs={12}>
          {renderField('employmentTitle', 'Employment Type')}
        </Grid>

        <Grid item xs={12}>
          {renderField('joiningDate', 'Joining Date')}
        </Grid>
      </Grid>
    </>
  );
}
